import { UserListIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const UserEdit = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <UserListIcon size={Sizes[size]} color={fill} {...rest} />;
};

UserEdit.displayName = 'UserEdit';
